var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 14,
    viewBox: "0 0 88 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.145 6.571c.8.194 1.58.464 2.33.808a4.87 4.87 0 0 1 1.882 1.601l-.157.106a4.495 4.495 0 0 0-.801-.889 5.022 5.022 0 0 0-1.005-.658 11.507 11.507 0 0 0-2.295-.793l.046-.175z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m87.621 9.27-.076-.11-.098.069.077.11.097-.068zM87.533 9.487l-.077-.11-.098.068.077.11.098-.068z",
    fill: "#CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m87.469 8.9.242.348-.38.265-.242-.348a.126.126 0 0 1 .031-.176l.174-.121a.126.126 0 0 1 .175.032zM4.932 6.571c-.802.194-1.583.464-2.333.808A4.851 4.851 0 0 0 .721 8.98l.154.106c.224-.33.491-.63.794-.889.308-.258.645-.48 1.005-.658.735-.345 1.506-.61 2.297-.793l-.039-.175z",
    fill: "#4D4D4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m.465 9.435.077-.11-.098-.068-.076.11.097.068zM.645 9.558l.077-.11-.098-.068-.077.11.098.068z",
    fill: "#CCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m.993 9.166-.243.348-.38-.265.242-.348A.127.127 0 0 1 .79 8.87l.174.12a.126.126 0 0 1 .031.177l-.001-.001z",
    fill: "#4D4D4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.871 7.178h1.72A.407.407 0 0 0 88 6.77V5.496a.407.407 0 0 0-.407-.407H85.87a.407.407 0 0 0-.407.407V6.77c0 .225.182.408.407.408z",
    fill: "#333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85.48 5.372a.355.355 0 0 1 .12-.02h1.72a.41.41 0 0 1 .41.41v1.284c-.001.04-.007.079-.017.117a.407.407 0 0 0 .286-.389v-1.28a.407.407 0 0 0-.407-.407h-1.723a.406.406 0 0 0-.388.285z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m83.85 6.441 3.411.201a.303.303 0 0 0 .32-.303v-.506a.3.3 0 0 0-.32-.301l-3.411.2v.71z",
    fill: "#4D4D4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m86.53 6.01.675-.006V5.7l-.675.028v.28zM85.726 6.017l.55-.006V5.74l-.55.022v.255zM85.054 6.023l.461-.004v-.25l-.461.021v.233zM84.49 6.028l.388-.003v-.23l-.389.018v.215zM86.53 6.445l.675.028v-.305l-.675-.006v.283zM85.726 6.412l.55.022V6.16l-.55-.003v.255zM85.054 6.384l.461.018v-.249l-.461-.004v.235zM84.49 6.361l.388.015v-.229l-.389-.001v.215zM87.463 7.373h-.217a.186.186 0 0 1-.186-.186v-.138h.59v.138a.186.186 0 0 1-.187.186zM86.486 7.373h-.223a.186.186 0 0 1-.186-.186v-.138h.597v.138a.185.185 0 0 1-.188.186zM1.26 6.96l-.732-.338a.218.218 0 0 1-.13-.201v-.579a.221.221 0 0 1 .13-.2l.733-.34V6.96z",
    fill: "#333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.26 5.303v.108l-.615.282A.25.25 0 0 0 .5 5.93V6.619a.225.225 0 0 1-.106-.185v-.592a.225.225 0 0 1 .128-.2l.738-.34z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6 5.405V6.86a.314.314 0 0 1-.315.314h-.898a.312.312 0 0 1-.213-.082.307.307 0 0 1-.104-.232V5.405a.316.316 0 0 1 .317-.318h.892a.32.32 0 0 1 .32.318z",
    fill: "#333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M2.585 5.33H1.468c-.17 0-.293.228-.293.486v1.278a.307.307 0 0 1-.105-.234V5.405a.316.316 0 0 1 .317-.318h.892a.313.313 0 0 1 .306.244z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m5.16 6.441-3.411.201a.303.303 0 0 1-.32-.303v-.506a.301.301 0 0 1 .32-.301l3.411.2v.71z",
    fill: "#4D4D4D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m2.477 6.01-.675-.006V5.7l.675.028v.28zM3.284 6.017 2.73 6.01V5.74l.553.022v.255zM3.955 6.023l-.46-.004v-.25l.46.021v.233zM4.52 6.028l-.39-.003v-.23l.39.018v.215zM2.477 6.445l-.675.028v-.305l.675-.006v.283zM3.284 6.412l-.553.022V6.16l.553-.003v.255zM3.955 6.384l-.46.018v-.249l.46-.004v.235zM4.52 6.361l-.39.015v-.229l.39-.001v.215z",
    fill: "#333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.792 6.998h-6.673v.98h6.673v-.98z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.373 7.667H9.536a.902.902 0 0 0-.902.902v1.088c0 .499.404.903.902.903h9.838a.902.902 0 0 0 .903-.903V8.57a.902.902 0 0 0-.902-.902z",
    fill: "#333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.957 6.998h-6.673v.98h6.673v-.98z",
    fill: "#1A1A1A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.54 7.667h-9.838a.902.902 0 0 0-.902.902v1.088c0 .499.404.903.902.903h9.838a.902.902 0 0 0 .903-.903V8.57a.902.902 0 0 0-.903-.902z",
    fill: "#333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.895 10.686a3.008 3.008 0 1 0-5.854-1.382 3.008 3.008 0 0 0 5.855 1.382z",
    fill: "gray"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.71 10.442a2.772 2.772 0 1 0-5.471-.888 2.772 2.772 0 0 0 5.472.888z",
    fill: "#4D4D4D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M69.88 10.307a1.93 1.93 0 1 0-3.812-.619 1.93 1.93 0 0 0 3.812.62z",
    fill: "#333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M68.574 9.996a.605.605 0 1 1-1.209 0 .605.605 0 0 1 1.21 0z",
    fill: "#4D4D4D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.42 12.775a3.008 3.008 0 1 0-2.302-5.558 3.008 3.008 0 0 0 2.302 5.558z",
    fill: "gray"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M81.23 11.956a2.772 2.772 0 1 0-3.92-3.92 2.772 2.772 0 0 0 3.92 3.92z",
    fill: "#4D4D4D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M80.635 11.36a1.93 1.93 0 1 0-2.73-2.73 1.93 1.93 0 0 0 2.73 2.73z",
    fill: "#333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.27 10.6a.605.605 0 1 0 0-1.209.605.605 0 0 0 0 1.21zM73.526 9.399h-1.834v.279h1.835v-.28zM73.526 9.9h-1.834v.278h1.835V9.9zM73.526 8.896h-1.834v.28h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m73.528 9.177-1.836.516v-.28l1.836-.517v.281z",
    fill: "gray"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M73.526 10.401h-1.834v.28h1.835v-.28zM73.526 10.911h-1.834v.28h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m73.528 9.678-1.836.517v-.279l1.836-.517v.279zM73.528 10.18l-1.836.516v-.28l1.836-.517v.281zM73.528 10.68l-1.836.518v-.281l1.836-.516v.28z",
    fill: "gray"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.526 8.396h-1.834v.28h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m73.528 8.676-1.836.517v-.28l1.836-.517v.28z",
    fill: "gray"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.547 9.399h-1.834v.279h1.834v-.28zM75.547 9.9h-1.834v.278h1.834V9.9zM75.547 8.896h-1.834v.28h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m75.547 9.177-1.834.516v-.28l1.834-.517v.281z",
    fill: "gray"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M75.547 10.401h-1.834v.28h1.834v-.28zM75.547 10.911h-1.834v.28h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m75.547 9.678-1.834.517v-.279l1.834-.517v.279zM75.547 10.18l-1.834.516v-.28l1.834-.517v.281zM75.547 10.68l-1.834.518v-.281l1.834-.516v.28z",
    fill: "gray"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M75.547 8.396h-1.834v.28h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m75.547 8.676-1.834.517v-.28l1.834-.517v.28z",
    fill: "gray"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M80.625 8.405a.93.93 0 0 0-.653-.342l-4.066-.309h-4.573l-4.066.31a.93.93 0 0 0-.815 1.221l.298.902h2.963l1.135 1.278a.887.887 0 0 0 .666.3h4.213a.892.892 0 0 0 .666-.3l1.135-1.277h2.963l.297-.903a.93.93 0 0 0-.163-.88zm-9.86 1.303a.218.218 0 0 1-.347.173l-1.056-.8v-.47a.186.186 0 0 1 .186-.185h1.04a.186.186 0 0 1 .185.186l-.007 1.096zm4.912.997a.372.372 0 0 1-.372.372h-3.37a.372.372 0 0 1-.371-.372V8.813a.372.372 0 0 1 .372-.372h3.369a.372.372 0 0 1 .372.372v1.892zm2.195-1.613-1.057.8a.218.218 0 0 1-.348-.173V8.623a.186.186 0 0 1 .186-.186h1.04a.186.186 0 0 1 .186.186l-.007.469z",
    fill: "gray"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M68.457 9.315h-.97a.195.195 0 0 0-.195.196v.969c0 .108.087.195.195.195h.97a.195.195 0 0 0 .195-.195v-.97a.195.195 0 0 0-.195-.195zM79.754 9.315h-.969a.195.195 0 0 0-.195.196v.969c0 .108.087.195.195.195h.97a.195.195 0 0 0 .195-.195v-.97a.195.195 0 0 0-.196-.195z",
    fill: "#4D4D4D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M9.946 12.78a3.008 3.008 0 1 0-2.28-5.567 3.008 3.008 0 0 0 2.28 5.567z",
    fill: "gray"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.54 10.44a2.772 2.772 0 1 0-5.47-.892 2.772 2.772 0 0 0 5.47.893z",
    fill: "#4D4D4D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54 11.782a1.93 1.93 0 1 0-1.47-3.571 1.93 1.93 0 0 0 1.47 3.571z",
    fill: "#333"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M8.806 10.6a.605.605 0 1 0 0-1.208.605.605 0 0 0 0 1.209z",
    fill: "#4D4D4D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.093 10.339a3.008 3.008 0 1 0-5.976-.687 3.008 3.008 0 0 0 5.976.687z",
    fill: "gray"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.858 10.311a2.772 2.772 0 1 0-5.507-.632 2.772 2.772 0 0 0 5.508.632z",
    fill: "#4D4D4D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.035 9.996a1.931 1.931 0 1 1-3.863 0 1.931 1.931 0 0 1 3.863 0z",
    fill: "#333"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.71 9.996a.604.604 0 1 1-1.209 0 .604.604 0 0 1 1.208 0zM14.363 9.399h-1.835v.279h1.835v-.28zM14.363 9.9h-1.835v.278h1.835V9.9zM14.363 8.896h-1.835v.28h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m14.363 9.177-1.835.516v-.28l1.835-.517v.281z",
    fill: "gray"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M14.363 10.401h-1.835v.28h1.835v-.28zM14.363 10.911h-1.835v.28h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "m14.363 9.678-1.835.517v-.279l1.835-.517v.279zM14.363 10.18l-1.835.516v-.28l1.835-.517v.281zM14.363 10.68l-1.835.518v-.281l1.835-.516v.28z",
    fill: "gray"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M14.363 8.396h-1.835v.28h1.835v-.28z",
    fill: "#4D4D4D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m14.363 8.676-1.835.517v-.28l1.835-.517v.28z",
    fill: "gray"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16.381 9.399h-1.834v.279h1.834v-.28zM16.381 9.9h-1.834v.278h1.834V9.9zM16.381 8.896h-1.834v.28h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m16.381 9.177-1.834.516v-.28l1.834-.517v.281z",
    fill: "gray"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16.381 10.401h-1.834v.28h1.834v-.28zM16.381 10.911h-1.834v.28h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "m16.381 9.678-1.834.517v-.279L16.38 9.4v.279zM16.381 10.18l-1.834.516v-.28L16.38 9.9v.281zM16.381 10.68l-1.834.518v-.281l1.834-.516v.28z",
    fill: "gray"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16.381 8.396h-1.834v.28h1.834v-.28z",
    fill: "#4D4D4D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m16.381 8.676-1.834.517v-.28l1.834-.517v.28z",
    fill: "gray"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M21.46 8.405a.931.931 0 0 0-.654-.342l-4.07-.309h-4.568l-4.067.31a.93.93 0 0 0-.814 1.214l.295.902h2.964l1.134 1.278a.896.896 0 0 0 .666.3h4.215a.897.897 0 0 0 .666-.3l1.135-1.278h2.963l.296-.902a.93.93 0 0 0-.162-.873zM11.6 9.708a.217.217 0 0 1-.347.173l-1.05-.79v-.468a.186.186 0 0 1 .186-.186h1.04a.186.186 0 0 1 .186.186L11.6 9.708zm4.911.997a.372.372 0 0 1-.372.372h-3.37a.372.372 0 0 1-.372-.372V8.813a.372.372 0 0 1 .372-.372h3.37a.372.372 0 0 1 .372.372v1.892zm2.193-1.613-1.056.8a.216.216 0 0 1-.346-.173V8.623a.186.186 0 0 1 .186-.186h1.034a.186.186 0 0 1 .186.186l-.004.469z",
    fill: "gray"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M8.32 9.315h.976a.186.186 0 0 1 .186.186v.972a.186.186 0 0 1-.186.185H8.32a.186.186 0 0 1-.186-.185V9.5a.186.186 0 0 1 .186-.186zM20.59 9.315h-.97a.195.195 0 0 0-.195.196v.969c0 .108.087.195.195.195h.97a.195.195 0 0 0 .195-.195v-.97a.195.195 0 0 0-.196-.195z",
    fill: "#4D4D4D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.904 5.213a.266.266 0 0 0 .22-.414.262.262 0 0 0-.466.169c0 .053.016.104.045.149a.259.259 0 0 0 .2.096zM41.966 5.214a.264.264 0 0 0 .255-.266.275.275 0 0 0-.045-.15.26.26 0 0 0-.463.17c0 .053.016.105.045.149a.257.257 0 0 0 .208.097zM14.358 4.713h-2.725v.551h2.725v-.55zM35.215 4.713H32.49v.551h2.725v-.55z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m84.677 5.762-.93 1.725H4.317l-.919-1.725a.259.259 0 0 1 .236-.359h80.814a.259.259 0 0 1 .229.36z",
    fill: "#000"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "m71.912 6.434-4.744.915-.448.085-.266.052-5.992 1.156a18.53 18.53 0 0 1-3.521.337H31.138c-1.031-.001-2.061-.088-3.078-.26-.149-.023-.296-.051-.445-.08l-5.993-1.154-.266-.052-.447-.086-4.747-.913h55.75z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.14 8.335c-1.142 0-2.28-.11-3.401-.326l-6.055-1.166H4.706l-.432-.794h79.52l-.425.794H66.393L60.336 8.01c-1.12.217-2.259.326-3.4.326H31.139z",
    fill: "#000",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.318 5.403H7.87v2.082h.448V5.403zM15.024 5.403h-.449v2.082h.449V5.403zM21.354 5.403h-.447v2.082h.447V5.403zM28.06 5.403V8.72c-.148-.024-.295-.052-.444-.08V5.403h.445zM34.39 5.403h-.447v3.574h.447V5.403zM41.096 5.403h-.447v3.574h.447V5.403zM47.426 5.403h-.447v3.574h.447V5.403zM54.13 5.403h-.446v3.574h.446V5.403zM60.462 5.403v3.239c-.147.028-.296.056-.444.08V5.403h.444zM67.168 5.403h-.448v2.082h.448V5.403zM73.498 5.403h-.448v2.082h.448V5.403zM80.204 5.403h-.446v2.082h.446V5.403z",
    fill: "#000"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M84.525 5.937V.146l-4.58 3h-70.5l-5.225-3v5.79h80.305z",
    fill: "#757575"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M84.525 3.937H4.22v.236h80.305v-.236z",
    fill: "#000"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4.218.146h-.653v5.79h.653V.147z",
    fill: "#757575"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4.23 5.954h-.68V.134h.68v5.82zm-.653-.034h.625V.168h-.625V5.92z",
    fill: "#000"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M84.517 5.942h.653V.15h-.653v5.79z",
    fill: "#757575"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M85.188 5.954h-.68V.134h.68v5.82zm-.653-.034h.625V.168h-.625V5.92z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellCar);
export default __webpack_public_path__ + "static/media/well_car.0eed63d250a3affd179afe251c37f5cb.svg";
export { ForwardRef as ReactComponent };